import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function useDataSession() {
  const [data, setData] = useState({});
  const store = useSelector((state) => state.authmodul_user_data);

  useEffect(() => {
    if (store.success) {
      setData(store.data);
    }
  }, [store]);

  return {
    selfUid: data.uId,
    session: data.session,
    listUser: data.listUser,
    dataSession: data,
  };
}
